import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '@app/shared/services/api.service';

export interface TagsMaster {
  id?: number;
  key: string;
  value: string;
  organization_id?: number;
  created_user_id?: number;
  created_datetime?: string;
  modified_user_id?: number;
  modified_datetime?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TagsMasterService {
  private apiEndpoint = '/tags-master';

  constructor(private api: ApiService) { }

  // Get all tags for organization
  getAllTags(): Observable<any[]> {
    return this.api.get(this.apiEndpoint).pipe(
      map((response: any) => {
        console.log('getAllTags - Full response received:', response);
        
        // Extract tags from response - handle all response formats
        let tagsArray = [];
        
        // HttpResponse format: response.body contains {responseHead, responseBody}
        if (response && response.body) {
          console.log('getAllTags - response.body exists:', response.body);
          
          // Try responseBody from body (APIResponse wrapper)
          if (response.body.responseBody && Array.isArray(response.body.responseBody)) {
            console.log('getAllTags - Using response.body.responseBody');
            tagsArray = response.body.responseBody;
          }
          // Try body is direct array
          else if (Array.isArray(response.body)) {
            console.log('getAllTags - Using response.body as array');
            tagsArray = response.body;
          }
        }
        // Direct array response
        else if (Array.isArray(response)) {
          console.log('getAllTags - Using direct array response');
          tagsArray = response;
        }
        
        console.log('getAllTags - Final tagsArray being returned:', tagsArray);
        return tagsArray;
      })
    );
  }

  // Get tag by ID
  getTagById(id: number): Observable<any> {
    return this.api.get(`${this.apiEndpoint}/${id}`);
  }

  // Create new tag
  createTag(tag: TagsMaster): Observable<any> {
    const payload = {
      requestBody: {
        key: tag.key,
        value: tag.value
      }
    };
    return this.api.post(this.apiEndpoint, payload);
  }

  // Update tag
  updateTag(id: number, tag: TagsMaster): Observable<any> {
    const payload = {
      requestBody: {
        key: tag.key,
        value: tag.value
      }
    };
    return this.api.put(`${this.apiEndpoint}/${id}`, payload);
  }

  // Delete tag
  deleteTag(id: number): Observable<any> {
    return this.api.delete(this.apiEndpoint, String(id));
  }

  // Helper method to generate reference ID
  private generateRefId(): string {
    return Math.random().toString(36).substr(2, 9);
  }

  // Helper method to format tags for dropdown
  formatTagsForDropdown(tags: TagsMaster[]): any[] {
    console.log('formatTagsForDropdown - Input tags:', tags);
    
    if (!tags || !Array.isArray(tags) || tags.length === 0) {
      console.log('formatTagsForDropdown - No tags to format');
      return [];
    }
    
    const formattedTags = tags.map(tag => ({
      id: tag.id,
      label: `${tag.key} (${tag.value})`,
      key: tag.key,
      value: tag.value
    }));
    
    console.log('formatTagsForDropdown - Formatted tags:', formattedTags);
    return formattedTags;
  }
}
